import { useState } from "react";

export const TextStackModal = ({ isOpen, onClose, stack, onLoad }) => {
  const [text, setText] = useState("");

  if (!isOpen) return null;

  const handleSaveText = () => {
    setText(JSON.stringify(stack, null, 2));
  };

  const handleLoadText = () => {
    try {
      const parsed = JSON.parse(text);

      if (!Array.isArray(parsed)) {
        alert(
          "Invalid text! This usually means you have one or more missing or wrong brackets."
        );
        return;
      }

      const migrated = parsed.map((item) => ({
        ...item,
        id: typeof item.id === "string" ? item.id : crypto.randomUUID(),
      }));

      onLoad(migrated);
      onClose();
    } catch (e) {
      alert(
        "Invalid text! This usually means you have one or more missing or wrong brackets."
      );
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          padding: 16,
          borderRadius: 8,
          width: 600,
        }}
      >
        <h3>Outfit from text</h3>

        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          style={{
            width: "100%",
            height: 250,
            marginBottom: 12,
          }}
          placeholder="Paste outfit JSON here…"
        />

        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={handleSaveText}>Save current outfit to text</button>
          <button onClick={handleLoadText}>Load outfit from text</button>
          <button onClick={onClose} style={{ marginLeft: "auto" }}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
